/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable @typescript-eslint/no-unsafe-enum-comparison */
'use client';

import { Dialog, DialogBackdrop, DialogPanel } from '@headlessui/react';
import { ChevronDoubleRightIcon } from '@heroicons/react/16/solid';
import { ChevronDoubleLeftIcon } from '@heroicons/react/24/outline';

import { ISideBarProps } from 'model/interfaces/header';
import { FC, useEffect, useState } from 'react';

import Icons from 'components/typed-icons';
import { CommonRoutes } from 'constants/routes.constants';
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate } from 'react-router-dom';
import './header.css';
import { useSelector } from 'react-redux';
import { RootState } from 'store/store';

export const SideBar: FC<ISideBarProps> = (props) => {
  const navigate = useNavigate();
  const location = useLocation();
  const { t } = useTranslation();
  const goToPage = (url: string) => {
    navigate(url);
  };
  const [activeMenu, setActiveMenu] = useState(1);
  const { isSJPR } = useSelector((state: RootState) => state.country);
  useEffect(() => {
    switch (location?.pathname) {
      case CommonRoutes.payAnalytics:
      case CommonRoutes.RewardBenchmarking:
      case CommonRoutes.Home:
        setActiveMenu(1);
        break;
      case CommonRoutes.singleJobPricing:
      case CommonRoutes.sjprSearchResults:
      case CommonRoutes.sjprPricingDetails:
        setActiveMenu(2);
        break;
      case CommonRoutes.myReports:
        setActiveMenu(3);
        break;
      default:
        setActiveMenu(1);
        break;
    }
  }, [location]);
  const menuOptions = (expanded = false, _width = '20px', _height = '20px') => {
    // eslint-disable-next-line react-hooks/rules-of-hooks

    return (
      <div
        className={`flex h-[100%] flex-col items-${expanded ? 'start px-[12px]' : 'center'} justify-between gap-[24px]`}
      >
        <div className={`flex flex-col items-${expanded ? 'start' : 'center'} gap-[24px]`}>
          <a
            onClick={() => {
              props.toggle();
            }}
            className='flex gap-[8px]'
          >
            {expanded ? (
              <ChevronDoubleLeftIcon
                aria-hidden='true'
                className='h-[24px] w-[24px] text-[#186855]'
              />
            ) : (
              <ChevronDoubleRightIcon
                aria-hidden='true'
                className='h-[24px] w-[24px] text-[#186855]'
              />
            )}
            {expanded && <span>{t('collapse')}</span>}
          </a>

          <div
            onClick={() => {
              if (expanded) props.toggle();
              goToPage(CommonRoutes.payAnalytics);
              setActiveMenu(1);
            }}
            className={`sidemenu-icon flex gap-[8px] ${activeMenu == 1 && (!expanded ? 'active-menu' : 'active-menu-exapnded')}`}
          >
            {/* <HomeIcon
              aria-hidden='true'
              className={`h-[${expanded ? '24px' : '20px'}] w-[${expanded ? '24px' : '20px'}]`}
            /> */}
            <img
              alt='React Logo'
              className={`h-[${_height}] w-[${_width}] common-icon`}
              src={typeof Icons.HomeIcon === 'string' ? Icons.HomeIcon : ''}
            />
            {expanded && <span>{t('pa.rewardBenchmarking')}</span>}
          </div>

          {isSJPR && <div
            onClick={() => {
              if (expanded) props.toggle();
              goToPage(CommonRoutes.singleJobPricing);
              setActiveMenu(2);
            }}
            className={`sidemenu-icon flex gap-[8px] ${activeMenu == 2 && (!expanded ? 'active-menu' : 'active-menu-exapnded')}`}
          >
            {/* <HomeIcon
              aria-hidden='true'
              className={`h-[${expanded ? '24px' : '20px'}] w-[${expanded ? '24px' : '20px'}]`}
            /> */}
            <img
              alt='React Logo'
              className={`h-[${_height}] w-[${_width}] common-icon`}
              src={typeof Icons.SJPRIcon === 'string' ? Icons.SJPRIcon : ''}
            />
            {expanded && <span>{t('pa.singleJobPricing')}</span>}
          </div>
          }
          <div
            onClick={() => {
              if (expanded) props.toggle();
              goToPage(CommonRoutes.myReports);
              setActiveMenu(3);
            }}
            className={`sidemenu-icon flex gap-[8px] ${activeMenu == 3 && (!expanded ? 'active-menu' : 'active-menu-exapnded')}`}
          >
            {/* <HomeIcon
              aria-hidden='true'
              className={`h-[${expanded ? '24px' : '20px'}] w-[${expanded ? '24px' : '20px'}]`}
            /> */}
            <img
              alt='React Logo'
              className={`h-[${_height}] w-[${_width}] common-icon`}
              src={typeof Icons.MyReportsIcon === 'string' ? Icons.MyReportsIcon : ''}
            />
            {expanded && <span>{t('pa.myreports')}</span>}
          </div>
        </div>
        <div
          className={`flex flex-col items-${expanded ? 'start gap-[16px]' : 'center gap-[16px]'} `}
        >
          {/* {expanded && <div className='tools-label'>{t('tools')}</div>}
          <div className='divider'>
          </div>
          <div
            onClick={() => {
              if (expanded) props.toggle();
              goToPage('/paypgcg/settings');
              setActiveMenu(4);
            }}
            className={`sidemenu-icon flex gap-[8px] ${activeMenu == 4 && (!expanded ? 'active-menu' : 'active-menu-exapnded')}`}
          >
            <Cog6ToothIcon aria-hidden='true' className={`h-[${_height}] w-[${_width}]`} />
            {expanded && <span>{t('settings')}</span>}
          </div>

          <div
            onClick={() => {
              if (expanded) props.toggle();
              setActiveMenu(5);
            }}
            className={`sidemenu-icon flex gap-[8px] ${activeMenu == 5 && (!expanded ? 'active-menu' : 'active-menu-exapnded')}`}
          >
            <QuestionMarkCircleIcon className={`h-[${_height}] w-[${_width}]`} />
            {expanded && <span>{t('helpCenter')}</span>}
          </div> */}
        </div>
      </div>
    );
  };
  return (
    <>
      <div className='app-sidemenu fixed inset-y-0 left-0 top-[64px] z-[10] flex w-[64px] flex-col bg-[#fff] p-[16px]'>
        {menuOptions()}
      </div>
      <Dialog
        open={props?.show}
        onClose={() => {
          props.toggle();
        }}
        className='relative z-10'
      >
        <DialogBackdrop
          transition
          className='fixed inset-0 bg-gray-500/75 transition-opacity duration-500 ease-in-out data-[closed]:opacity-0'
        />

        <div className='fixed inset-0 overflow-hidden'>
          <div className='absolute inset-0 overflow-hidden'>
            <div className='pointer-events-none fixed inset-y-0 left-0 top-[48px] flex max-w-full pl-0'>
              <DialogPanel
                transition
                className='pointer-events-auto relative w-screen max-w-[264px] transform transition duration-500 ease-in-out data-[closed]:-translate-x-full sm:duration-700'
              >
                <div className='expanded-view flex h-full flex-col overflow-hidden bg-white py-6 pb-[0] shadow-xl'>
                  {menuOptions(true)}
                  <div className='relative mt-6 flex-1 px-4 sm:px-6'>{/* Your content */}</div>
                </div>
              </DialogPanel>
            </div>
          </div>
        </div>
      </Dialog>
    </>
  );
};
